import { takeEvery, all, put, call, select } from 'redux-saga/effects'

import {
  FETCH_PENDING_CONSENT_REQUEST,
  APPROVE_CONSENT_REQUEST,
} from 'containers/app/constants'
import {
  authenticateFailure,
  fetchPendingUserConsentFailure,
  fetchPendingUserConsentSuccess,
  approveUserConsentSuccess,
  approveUserConsentFailure,
} from 'containers/app/actions'
import * as argus from 'api/argus'
import { getUserConsent } from 'containers/app/selectors'

function* fetchConsent() {
  try {
    const response = yield call(argus.fetchData, '/secure/user-consent/pending')
    yield put(fetchPendingUserConsentSuccess(response))
  } catch ({ error, response }) {
    yield put(fetchPendingUserConsentFailure('Failed to fetch user consent'))
    if (response && response.status === 401) {
      yield put(authenticateFailure())
    }
  }
}

function* approveConsent() {
  const consent = yield select(getUserConsent)

  try {
    yield call(
      argus.postData,
      '/secure/user-consent/approve',
      {
        body: {
          id: consent.id,
          approvalDeviceType: 'web',
        },
      },
      false,
    )
    yield put(approveUserConsentSuccess())
  } catch ({ error, response }) {
    yield put(approveUserConsentFailure(error.message))
  }
}

function* watchFetchConsent() {
  yield takeEvery(FETCH_PENDING_CONSENT_REQUEST, fetchConsent)
}

function* watchConsentApproval() {
  yield takeEvery(APPROVE_CONSENT_REQUEST, approveConsent)
}

function* consentSagas() {
  yield all([watchFetchConsent(), watchConsentApproval()])
}

export default consentSagas
